__turbopack_context__.v({
  "banner": "styles-module__IIYnJW__banner",
  "body": "styles-module__IIYnJW__body",
  "content": "styles-module__IIYnJW__content",
  "illustration": "styles-module__IIYnJW__illustration",
  "signupLink": "styles-module__IIYnJW__signupLink",
  "text": "styles-module__IIYnJW__text",
  "title": "styles-module__IIYnJW__title",
});
